// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__KF+9b","meals-appear":"AvailableMeals_meals-appear__vAZw1","load":"AvailableMeals_load__xqa2Q","error":"AvailableMeals_error__Hu268"};